/** Returns true when the props are of type {@link DayPickerMultipleProps}. */
export function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}
//# sourceMappingURL=DayPickerMultiple.js.map